import { z } from 'zod';

import type { SearchExperimentLayer } from '@atlassian/search-experiment/dynamic/types';

import { PageStatusFilterValueKey } from '../filters/page-status-filter';
import { TypeFilterValueKey } from '../filters/universal-type';
import { type ProductKeys as ProductKeysFromProducts } from '../product-keys';
import { allContentTypeSchema } from './all-content-type-schema';
import { asanaContentTypeSchema } from './asana-content-type-schema';
import { assetsContentTypeSchema } from './assets-content-type-schema';
import { atlasContentTypeSchema } from './atlas-content-type-schema';
import { booleanSchema } from './boolean-schema';
import { commaSeparatedArraySchema } from './comma-separated-array-schema';
import { compassContentTypeSchema } from './compass-content-type-schema';
import { confluenceContentTypeSchema } from './confluence-content-type-schema';
import { databricksContentTypeSchema } from './databricks-content-type-schema';
import { dropboxContentTypeSchema } from './dropbox-content-type-schema';
import { figmaContentTypeSchema } from './figma-content-type-schema';
import { githubContentTypeSchema } from './github-content-type-schema';
import { googleContentTypeSchema } from './google-content-type-schema';
import { hubspotContentTypeSchema } from './hubspot-content-type-schema';
import { jiraContentTypeSchema } from './jira-content-type-schema';
import { lastModifiedValueSchema } from './last-modified-value-schema';
import { loomContentTypeSchema } from './loom-content-type-schema';
import { mercuryContentTypeSchema } from './mercury-content-type-schema';
import { microsoftContentTypeSchema } from './microsoft-content-type-schema';
import { ProductKey } from './product-key';
import { productKeySchema } from './product-key-schema';
import { salesforceContentTypeSchema } from './salesforce-content-type-schema';
import { servicenowContentTypeSchema } from './servicenow-content-type-schema';
import { slackContentTypeSchema } from './slack-content-type-schema';
import { smartLinksContentTypeSchema } from './smart-links-content-type-schema';
import { sortSchema } from './sort-schema';
import { talentContentTypeSchema } from './talent-content-type-schema';
import { teamsContentTypeSchema } from './teams-content-type-schema';
import { trelloContentTypeSchema } from './trello-content-type-schema';
import { webPageContentTypeSchema } from './web-page-content-type-schema';
import { zendeskContentTypeSchema } from './zendesk-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { booleanSchema } from './boolean-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { commaSeparatedArraySchema } from './comma-separated-array-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { productKeySchema } from './product-key-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ProductKey } from './product-key';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { allContentTypeSchema } from './all-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { atlasContentTypeSchema } from './atlas-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { asanaContentTypeSchema } from './asana-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { confluenceContentTypeSchema } from './confluence-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { googleContentTypeSchema } from './google-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { microsoftContentTypeSchema } from './microsoft-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { dropboxContentTypeSchema } from './dropbox-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { jiraContentTypeSchema } from './jira-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { compassContentTypeSchema } from './compass-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { mercuryContentTypeSchema } from './mercury-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { talentContentTypeSchema } from './talent-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { trelloContentTypeSchema } from './trello-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { slackContentTypeSchema } from './slack-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { teamsContentTypeSchema } from './teams-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { githubContentTypeSchema } from './github-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { webPageContentTypeSchema } from './web-page-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { figmaContentTypeSchema } from './figma-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { loomContentTypeSchema } from './loom-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { zendeskContentTypeSchema } from './zendesk-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { smartLinksContentTypeSchema } from './smart-links-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { salesforceContentTypeSchema } from './salesforce-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { databricksContentTypeSchema } from './databricks-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { hubspotContentTypeSchema } from './hubspot-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { servicenowContentTypeSchema } from './servicenow-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { assetsContentTypeSchema } from './assets-content-type-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { lastModifiedValueSchema } from './last-modified-value-schema';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { sortSchema } from './sort-schema';

// Use the same ProductKeys type as products.tsx to ensure type compatibility
// This avoids needing casts everywhere - both types are now identical
export type ProductKeys = ProductKeysFromProducts;
export type AllContentTypes = z.infer<typeof allContentTypeSchema>;
export const AllContentType: {
	All: string;
} = allContentTypeSchema.enum;

export type AtlasContentTypes = z.infer<typeof atlasContentTypeSchema>;
export const AtlasContentType: {
	readonly Goal: 'goal';
	readonly Learning: 'learning';
	readonly Project: 'project';
	readonly Tag: 'tag';
} = atlasContentTypeSchema.enum;

export type AsanaContentType = z.infer<typeof asanaContentTypeSchema>;
export const AsanaContentType: {
	readonly WorkItem: 'work-item';
} = asanaContentTypeSchema.enum;

export type ConfluenceContentTypes = z.infer<typeof confluenceContentTypeSchema>;
export const ConfluenceContentType: {
	readonly Answer: 'answer';
	readonly Attachment: 'attachment';
	readonly Blogpost: 'blogpost';
	readonly Calendar: 'calendar';
	readonly Comment: 'comment';
	readonly Database: 'database';
	readonly Document: 'document';
	readonly Embed: 'embed';
	readonly Folder: 'folder';
	readonly Gliffy: 'gliffy';
	readonly Page: 'page';
	readonly Question: 'question';
	readonly Space: 'space';
	readonly SpaceCalendar: 'space-calendar';
	readonly Whiteboard: 'whiteboard';
	readonly Slide: 'slide';
} = confluenceContentTypeSchema.enum;

export type GoogleContentTypes = z.infer<typeof googleContentTypeSchema>;
export const GoogleContentType: {
	readonly Document: 'document';
	readonly Presentation: 'presentation';
	readonly Spreadsheet: 'spreadsheet';
	readonly Video: 'video';
	readonly Image: 'image';
	readonly Folder: 'folder';
	readonly Audio: 'audio';
	readonly Pdf: 'pdf';
	readonly Code: 'code';
	readonly Form: 'form';
	readonly Notebook: 'notebook';
	readonly WebPage: 'web-page';
	readonly Other: 'other';
} = googleContentTypeSchema.enum;

export type MicrosoftContentTypes = z.infer<typeof microsoftContentTypeSchema>;
export const MicrosoftContentType: {
	readonly Document: 'document';
	readonly Presentation: 'presentation';
	readonly Spreadsheet: 'spreadsheet';
	readonly Image: 'image';
	readonly Folder: 'folder';
	readonly Video: 'video';
	readonly Pdf: 'pdf';
	readonly Shortcut: 'shortcut';
	readonly Archive: 'archive';
	readonly WebPage: 'web-page';
	readonly Page: 'page';
	readonly Blogpost: 'blogpost';
	readonly Notebook: 'notebook';
	readonly Other: 'other';
} = microsoftContentTypeSchema.enum;

export type DropboxContentTypes = z.infer<typeof dropboxContentTypeSchema>;
export const DropboxContentType: {
	readonly Document: 'document';
	readonly Presentation: 'presentation';
	readonly Spreadsheet: 'spreadsheet';
} = dropboxContentTypeSchema.enum;

export type JiraContentTypes = z.infer<typeof jiraContentTypeSchema>;
export const JiraContentType: {
	readonly Project: 'project';
	readonly Incident: 'incident';
	readonly Issue: 'issue';
	readonly Filter: 'filter';
	readonly Dashboard: 'dashboard';
	readonly Board: 'board';
	readonly Plan: 'plan';
	readonly Epic: 'epic';
	readonly Bug: 'bug';
	readonly Story: 'story';
	readonly Task: 'task';
	readonly Subtask: 'subtask';
} = jiraContentTypeSchema.enum;

export type CompassContentTypes = z.infer<typeof compassContentTypeSchema>;
export const CompassContentType: {
	readonly Component: 'component';
} = compassContentTypeSchema.enum;

export type MercuryContentTypes = z.infer<typeof mercuryContentTypeSchema>;
export const MercuryContentType: {
	readonly FocusArea: 'focus-area';
	readonly Ask: 'ask';
	readonly Organization: 'organization';
	readonly Risk: 'risk';
} = mercuryContentTypeSchema.enum;

export type TalentContentTypes = z.infer<typeof talentContentTypeSchema>;
export const TalentContentType: {
	readonly Position: 'position';
} = talentContentTypeSchema.enum;

export type TrelloContentTypes = z.infer<typeof trelloContentTypeSchema>;
export const TrelloContentType: {
	readonly Board: 'board';
	readonly Card: 'card';
} = trelloContentTypeSchema.enum;

export type SlackContentTypes = z.infer<typeof slackContentTypeSchema>;
export const SlackContentType: {
	readonly Message: 'message';
	readonly Conversation: 'conversation';
} = slackContentTypeSchema.enum;

export type TeamsContentTypes = z.infer<typeof teamsContentTypeSchema>;
export const TeamsContentType: {
	readonly Message: 'message';
	readonly Conversation: 'conversation';
	readonly Video: 'video';
	readonly Attachment: 'attachment';
} = teamsContentTypeSchema.enum;
export type GithubContentType = z.infer<typeof githubContentTypeSchema>;
export const GithubContentType: {
	readonly Repository: 'repository';
	readonly PullRequest: 'pull-request';
	readonly Commit: 'commit';
	readonly Branch: 'branch';
	readonly DevopsWorkItem: 'devops-work-item';
} = githubContentTypeSchema.enum;

export type WebPageContentTypes = z.infer<typeof webPageContentTypeSchema>;
export const WebPageContentType: {
	readonly WebPage: 'web-page';
} = webPageContentTypeSchema.enum;

export type FigmaContentTypes = z.infer<typeof figmaContentTypeSchema>;
export const FigmaContentType: {
	readonly Design: 'design';
} = figmaContentTypeSchema.enum;

export type LoomContentTypes = z.infer<typeof loomContentTypeSchema>;
export const LoomContentType: {
	readonly Video: 'video';
	readonly AsyncVideo: 'async-video';
	readonly MeetingRecording: 'meeting-recording';
	readonly Playlist: 'playlist';
	readonly Tag: 'tag';
	readonly Space: 'space';
	readonly Folder: 'folder';
} = loomContentTypeSchema.enum;

export type ZendeskContentType = z.infer<typeof zendeskContentTypeSchema>;
export const ZendeskContentType: {
	readonly WorkItem: 'work-item';
	readonly Document: 'document';
	readonly Article: 'article';
	readonly Post: 'post';
	readonly Ticket: 'ticket';
	readonly Comment: 'comment';
} = zendeskContentTypeSchema.enum;

export type SmartLinksContentType = z.infer<typeof smartLinksContentTypeSchema>;
export const SmartLinksContentType: {
	readonly Dashboard: 'dashboard';
	readonly Invoice: 'invoice';
	readonly Deal: 'deal';
} = smartLinksContentTypeSchema.enum;

export type SalesforceContentTypes = z.infer<typeof salesforceContentTypeSchema>;
export const SalesforceContentType: {
	readonly Deal: 'deal';
	readonly CustomerContact: 'customer-contact';
	readonly CustomerOrg: 'customer-org';
	readonly Campaign: 'campaign';
	readonly Case: 'case';
	readonly Lead: 'lead';
} = salesforceContentTypeSchema.enum;

export type DatabricksContentTypes = z.infer<typeof databricksContentTypeSchema>;
export const DatabricksContentType: {
	readonly Dashboard: 'dashboard';
	readonly DataTable: 'data-table';
} = databricksContentTypeSchema.enum;

export type HubspotContentTypes = z.infer<typeof hubspotContentTypeSchema>;
export const HubspotContentType: {
	readonly Deal: 'deal';
	readonly CustomerOrg: 'customer-org';
} = hubspotContentTypeSchema.enum;

export type ServiceNowContentType = z.infer<typeof servicenowContentTypeSchema>;
export const ServiceNowContentType: {
	readonly WorkItem: 'work-item';
	readonly Document: 'document';
	readonly Comment: 'comment';
	readonly Incident: 'incident';
	readonly Epic: 'epic';
	readonly CatalogItem: 'catalog-item';
	readonly RequestedItem: 'requested-item';
	readonly Project: 'project';
	readonly Demand: 'demand';
	readonly KnowledgeArticle: 'knowledge-article';
	readonly NewsArticle: 'news-article';
} = servicenowContentTypeSchema.enum;

export const AssetsContentType: {
	readonly AssetsObject: 'object';
	readonly Schema: 'schema';
	readonly Type: 'type';
} = assetsContentTypeSchema.enum;
export type AssetsContentTypes = z.infer<typeof assetsContentTypeSchema>;

// this is the original enum (prior to using TypeFilterValueKey), it is only used for testing purposes for now
export const contentTypeSchemaOriginal: z.ZodNativeEnum<{
	readonly Position: 'position';
	readonly AssetsObject: 'object';
	readonly Schema: 'schema';
	readonly Type: 'type';
	readonly Dashboard: 'dashboard';
	readonly DataTable: 'data-table';
	readonly Deal: 'deal';
	readonly CustomerOrg: 'customer-org';
	readonly CustomerContact: 'customer-contact';
	readonly Campaign: 'campaign';
	readonly Case: 'case';
	readonly Invoice: 'invoice';
	readonly WorkItem: 'work-item';
	readonly Document: 'document';
	readonly Presentation: 'presentation';
	readonly Spreadsheet: 'spreadsheet';
	readonly WebPage: 'web-page';
	readonly Video: 'video';
	readonly AsyncVideo: 'async-video';
	readonly MeetingRecording: 'meeting-recording';
	readonly Playlist: 'playlist';
	readonly Repository: 'repository';
	readonly PullRequest: 'pull-request';
	readonly Commit: 'commit';
	readonly DevopsWorkItem: 'devops-work-item';
	readonly Branch: 'branch';
	readonly Design: 'design';
	readonly Message: 'message';
	readonly Conversation: 'conversation';
	readonly Attachment: 'attachment';
	readonly Board: 'board';
	readonly Card: 'card';
	readonly FocusArea: 'focus-area';
	readonly Organization: 'organization';
	readonly Ask: 'ask';
	readonly Risk: 'risk';
	readonly Component: 'component';
	readonly Project: 'project';
	readonly Incident: 'incident';
	readonly Issue: 'issue';
	readonly Filter: 'filter';
	readonly Plan: 'plan';
	readonly Epic: 'epic';
	readonly Bug: 'bug';
	readonly Story: 'story';
	readonly Task: 'task';
	readonly Subtask: 'subtask';
	readonly Image: 'image';
	readonly Folder: 'folder';
	readonly Audio: 'audio';
	readonly Pdf: 'pdf';
	readonly Shortcut: 'shortcut';
	readonly Code: 'code';
	readonly Archive: 'archive';
	readonly Form: 'form';
	readonly Page: 'page';
	readonly Blogpost: 'blogpost';
	readonly Notebook: 'notebook';
	readonly Other: 'other';
	readonly Answer: 'answer';
	readonly Calendar: 'calendar';
	readonly Comment: 'comment';
	readonly Database: 'database';
	readonly Embed: 'embed';
	readonly Gliffy: 'gliffy';
	readonly Question: 'question';
	readonly Space: 'space';
	readonly SpaceCalendar: 'space-calendar';
	readonly Whiteboard: 'whiteboard';
	readonly Slide: 'slide';
	readonly Goal: 'goal';
	readonly Learning: 'learning';
	readonly Tag: 'tag';
	readonly Article: 'article';
	readonly Post: 'post';
	readonly Ticket: 'ticket';
	readonly CatalogItem: 'catalog-item';
	readonly RequestedItem: 'requested-item';
	readonly Demand: 'demand';
	readonly KnowledgeArticle: 'knowledge-article';
	readonly NewsArticle: 'news-article';
	readonly Lead: 'lead';
	readonly All: string;
}> = z.nativeEnum({
	...AllContentType,
	...AsanaContentType,
	...AtlasContentType,
	...ConfluenceContentType,
	...GoogleContentType,
	...MicrosoftContentType,
	...JiraContentType,
	...CompassContentType,
	...MercuryContentType,
	...TrelloContentType,
	...SlackContentType,
	...TeamsContentType,
	...FigmaContentType,
	...GithubContentType,
	...LoomContentType,
	...WebPageContentType,
	...DropboxContentType,
	...ZendeskContentType,
	...SmartLinksContentType,
	...SalesforceContentType,
	...HubspotContentType,
	...DatabricksContentType,
	...AssetsContentType,
	...TalentContentType,
	...ServiceNowContentType,
} as const);

export const contentTypeSchema: z.ZodNativeEnum<{
	readonly All: string;
	readonly Document: 'document';
	readonly Spreadsheet: 'spreadsheet';
	readonly Presentation: 'presentation';
	readonly Repository: 'repository';
	readonly PullRequest: 'pull-request';
	readonly Branch: 'branch';
	readonly Commit: 'commit';
	readonly DevopsWorkItem: 'devops-work-item';
	readonly WebPage: 'web-page';
	readonly Conversation: 'conversation';
	readonly Message: 'message';
	readonly Video: 'video';
	readonly AsyncVideo: 'async-video';
	readonly MeetingRecording: 'meeting-recording';
	readonly Playlist: 'playlist';
	readonly Design: 'design';
	readonly Page: 'page';
	readonly Blogpost: 'blogpost';
	readonly Attachment: 'attachment';
	readonly Space: 'space';
	readonly Whiteboard: 'whiteboard';
	readonly Slide: 'slide';
	readonly Comment: 'comment';
	readonly Database: 'database';
	readonly Embed: 'embed';
	readonly Folder: 'folder';
	readonly Calendar: 'calendar';
	readonly SpaceCalendar: 'space-calendar';
	readonly Question: 'question';
	readonly Answer: 'answer';
	readonly Issue: 'issue';
	readonly Epic: 'epic';
	readonly Bug: 'bug';
	readonly Story: 'story';
	readonly Task: 'task';
	readonly Subtask: 'subtask';
	readonly Project: 'project';
	readonly Incident: 'incident';
	readonly Filter: 'filter';
	readonly Plan: 'plan';
	readonly Board: 'board';
	readonly Component: 'component';
	readonly Card: 'card';
	readonly Goal: 'goal';
	readonly Tag: 'tag';
	readonly WorkItem: 'work-item';
	readonly FocusArea: 'focus-area';
	readonly Organization: 'organization';
	readonly Ask: 'ask';
	readonly Risk: 'risk';
	readonly Dashboard: 'dashboard';
	readonly Invoice: 'invoice';
	readonly Deal: 'deal';
	readonly Gliffy: 'gliffy';
	readonly CustomerContact: 'customer-contact';
	readonly CustomerOrg: 'customer-org';
	readonly Campaign: 'campaign';
	readonly Case: 'case';
	readonly DataTable: 'data-table';
	readonly AssetsObject: 'object';
	readonly Type: 'type';
	readonly Schema: 'schema';
	readonly Position: 'position';
	readonly Image: 'image';
	readonly Audio: 'audio';
	readonly Pdf: 'pdf';
	readonly Shortcut: 'shortcut';
	readonly Code: 'code';
	readonly Archive: 'archive';
	readonly Other: 'other';
	readonly Notebook: 'notebook';
	readonly Form: 'form';
	readonly Article: 'article';
	readonly Post: 'post';
	readonly Ticket: 'ticket';
	readonly CatalogItem: 'catalog-item';
	readonly RequestedItem: 'requested-item';
	readonly Demand: 'demand';
	readonly KnowledgeArticle: 'knowledge-article';
	readonly NewsArticle: 'news-article';
	readonly Lead: 'lead';
}> = z.nativeEnum({
	...TypeFilterValueKey,
	...AllContentType,
} as const);

export type ContentTypes = z.infer<typeof contentTypeSchema>;
export const ContentType: {
	readonly All: string;
	readonly Document: 'document';
	readonly Spreadsheet: 'spreadsheet';
	readonly Presentation: 'presentation';
	readonly Repository: 'repository';
	readonly PullRequest: 'pull-request';
	readonly Branch: 'branch';
	readonly Commit: 'commit';
	readonly DevopsWorkItem: 'devops-work-item';
	readonly WebPage: 'web-page';
	readonly Conversation: 'conversation';
	readonly Message: 'message';
	readonly Video: 'video';
	readonly AsyncVideo: 'async-video';
	readonly MeetingRecording: 'meeting-recording';
	readonly Playlist: 'playlist';
	readonly Design: 'design';
	readonly Page: 'page';
	readonly Blogpost: 'blogpost';
	readonly Attachment: 'attachment';
	readonly Space: 'space';
	readonly Whiteboard: 'whiteboard';
	readonly Slide: 'slide';
	readonly Comment: 'comment';
	readonly Database: 'database';
	readonly Embed: 'embed';
	readonly Folder: 'folder';
	readonly Calendar: 'calendar';
	readonly SpaceCalendar: 'space-calendar';
	readonly Question: 'question';
	readonly Answer: 'answer';
	readonly Issue: 'issue';
	readonly Epic: 'epic';
	readonly Bug: 'bug';
	readonly Story: 'story';
	readonly Task: 'task';
	readonly Subtask: 'subtask';
	readonly Project: 'project';
	readonly Incident: 'incident';
	readonly Filter: 'filter';
	readonly Plan: 'plan';
	readonly Board: 'board';
	readonly Component: 'component';
	readonly Card: 'card';
	readonly Goal: 'goal';
	readonly Tag: 'tag';
	readonly WorkItem: 'work-item';
	readonly FocusArea: 'focus-area';
	readonly Organization: 'organization';
	readonly Ask: 'ask';
	readonly Risk: 'risk';
	readonly Dashboard: 'dashboard';
	readonly Invoice: 'invoice';
	readonly Deal: 'deal';
	readonly Gliffy: 'gliffy';
	readonly CustomerContact: 'customer-contact';
	readonly CustomerOrg: 'customer-org';
	readonly Campaign: 'campaign';
	readonly Case: 'case';
	readonly DataTable: 'data-table';
	readonly AssetsObject: 'object';
	readonly Type: 'type';
	readonly Schema: 'schema';
	readonly Position: 'position';
	readonly Image: 'image';
	readonly Audio: 'audio';
	readonly Pdf: 'pdf';
	readonly Shortcut: 'shortcut';
	readonly Code: 'code';
	readonly Archive: 'archive';
	readonly Other: 'other';
	readonly Notebook: 'notebook';
	readonly Form: 'form';
	readonly Article: 'article';
	readonly Post: 'post';
	readonly Ticket: 'ticket';
	readonly CatalogItem: 'catalog-item';
	readonly RequestedItem: 'requested-item';
	readonly Demand: 'demand';
	readonly KnowledgeArticle: 'knowledge-article';
	readonly NewsArticle: 'news-article';
	readonly Lead: 'lead';
} = contentTypeSchema.enum;

export const pageStatusSchema: z.ZodNativeEnum<{
	All: string;
	RoughDraft: 'roughDraft';
	InProgress: 'inProgress';
	ReadyForReview: 'readyForReview';
	Verified: 'verified';
}> = z.nativeEnum({
	...PageStatusFilterValueKey,
	...AllContentType,
});

export const LastModified: {
	readonly Anytime: 'anytime';
	readonly Today: 'today';
	readonly Yesterday: 'yesterday';
	readonly Past7Days: 'past7Days';
	readonly Past30Days: 'past30Days';
	readonly PastYear: 'pastYear';
	readonly Custom: 'custom';
} = lastModifiedValueSchema.enum;
export type LastModifiedValue = z.infer<typeof lastModifiedValueSchema>;

export const Sort: {
	readonly Relevance: 'relevance';
	readonly UpdatedNewest: 'updatedNewest';
	readonly UpdatedOldest: 'updatedOldest';
	readonly CreatedNewest: 'createdNewest';
	readonly CreatedOldest: 'createdOldest';
} = sortSchema.enum;
export type SortValue = z.infer<typeof sortSchema>;

/**
 * Backend experiment override format accepted via URL overrides.
 */
export type BackendExperimentOverride = Pick<SearchExperimentLayer, 'analyticsDefinitions'> & {
	name:
		| 'search_platform_layer_l1'
		| 'search_platform_layer_l2'
		| 'search_platform_layer_l3'
		| 'search_platform_layer_query_expansion';
};

export type Overrides = {
	sourceProduct?: string;
	frontendFeatureGates?: Array<{
		name: string;
		value: boolean;
	}>;
	frontendExperiments?: Array<{
		name: string;
		value: Record<string, string | boolean>;
	}>;
	backendExperiments?: BackendExperimentOverride[];
};

const jsonEncodedSchema = <T extends z.ZodTypeAny>(schema: T) =>
	z.preprocess((value) => {
		// Expected format: URL encoded JSON string
		if (typeof value === 'string') {
			let decoded = value;
			try {
				decoded = decodeURIComponent(value);
			} catch {
				// ignore decoding errors; schema will fail if JSON is invalid
			}
			try {
				return JSON.parse(decoded);
			} catch {
				return value;
			}
		}
		return value;
	}, schema);

export const overridesSchema: z.ZodEffects<
	z.ZodObject<
		{
			sourceProduct: z.ZodOptional<z.ZodString>;
			frontendFeatureGates: z.ZodOptional<
				z.ZodArray<
					z.ZodObject<
						{
							name: z.ZodString;
							value: z.ZodBoolean;
						},
						'strip',
						z.ZodTypeAny,
						{
							name: string;
							value: boolean;
						},
						{
							name: string;
							value: boolean;
						}
					>,
					'many'
				>
			>;
			frontendExperiments: z.ZodOptional<
				z.ZodArray<
					z.ZodObject<
						{
							name: z.ZodString;
							value: z.ZodRecord<z.ZodString, z.ZodUnion<[z.ZodString, z.ZodBoolean]>>;
						},
						'strip',
						z.ZodTypeAny,
						{
							name: string;
							value: Record<string, string | boolean>;
						},
						{
							name: string;
							value: Record<string, string | boolean>;
						}
					>,
					'many'
				>
			>;
			backendExperiments: z.ZodOptional<
				z.ZodArray<
					z.ZodObject<
						{
							name: z.ZodEnum<
								[
									'search_platform_layer_l1',
									'search_platform_layer_l2',
									'search_platform_layer_l3',
									'search_platform_layer_query_expansion',
								]
							>;
							analyticsDefinitions: z.ZodOptional<
								z.ZodArray<
									z.ZodObject<
										{
											layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											abTestId: z.ZodNullable<z.ZodString>;
											armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											controlId: z.ZodNullable<z.ZodString>;
										},
										'passthrough',
										z.ZodTypeAny,
										z.objectOutputType<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											z.ZodTypeAny,
											'passthrough'
										>,
										z.objectInputType<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											z.ZodTypeAny,
											'passthrough'
										>
									>,
									'many'
								>
							>;
						},
						'passthrough',
						z.ZodTypeAny,
						z.objectOutputType<
							{
								name: z.ZodEnum<
									[
										'search_platform_layer_l1',
										'search_platform_layer_l2',
										'search_platform_layer_l3',
										'search_platform_layer_query_expansion',
									]
								>;
								analyticsDefinitions: z.ZodOptional<
									z.ZodArray<
										z.ZodObject<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											'passthrough',
											z.ZodTypeAny,
											z.objectOutputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>,
											z.objectInputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>
										>,
										'many'
									>
								>;
							},
							z.ZodTypeAny,
							'passthrough'
						>,
						z.objectInputType<
							{
								name: z.ZodEnum<
									[
										'search_platform_layer_l1',
										'search_platform_layer_l2',
										'search_platform_layer_l3',
										'search_platform_layer_query_expansion',
									]
								>;
								analyticsDefinitions: z.ZodOptional<
									z.ZodArray<
										z.ZodObject<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											'passthrough',
											z.ZodTypeAny,
											z.objectOutputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>,
											z.objectInputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>
										>,
										'many'
									>
								>;
							},
							z.ZodTypeAny,
							'passthrough'
						>
					>,
					'many'
				>
			>;
		},
		'passthrough',
		z.ZodTypeAny,
		z.objectOutputType<
			{
				sourceProduct: z.ZodOptional<z.ZodString>;
				frontendFeatureGates: z.ZodOptional<
					z.ZodArray<
						z.ZodObject<
							{
								name: z.ZodString;
								value: z.ZodBoolean;
							},
							'strip',
							z.ZodTypeAny,
							{
								name: string;
								value: boolean;
							},
							{
								name: string;
								value: boolean;
							}
						>,
						'many'
					>
				>;
				frontendExperiments: z.ZodOptional<
					z.ZodArray<
						z.ZodObject<
							{
								name: z.ZodString;
								value: z.ZodRecord<z.ZodString, z.ZodUnion<[z.ZodString, z.ZodBoolean]>>;
							},
							'strip',
							z.ZodTypeAny,
							{
								name: string;
								value: Record<string, string | boolean>;
							},
							{
								name: string;
								value: Record<string, string | boolean>;
							}
						>,
						'many'
					>
				>;
				backendExperiments: z.ZodOptional<
					z.ZodArray<
						z.ZodObject<
							{
								name: z.ZodEnum<
									[
										'search_platform_layer_l1',
										'search_platform_layer_l2',
										'search_platform_layer_l3',
										'search_platform_layer_query_expansion',
									]
								>;
								analyticsDefinitions: z.ZodOptional<
									z.ZodArray<
										z.ZodObject<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											'passthrough',
											z.ZodTypeAny,
											z.objectOutputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>,
											z.objectInputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>
										>,
										'many'
									>
								>;
							},
							'passthrough',
							z.ZodTypeAny,
							z.objectOutputType<
								{
									name: z.ZodEnum<
										[
											'search_platform_layer_l1',
											'search_platform_layer_l2',
											'search_platform_layer_l3',
											'search_platform_layer_query_expansion',
										]
									>;
									analyticsDefinitions: z.ZodOptional<
										z.ZodArray<
											z.ZodObject<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												'passthrough',
												z.ZodTypeAny,
												z.objectOutputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>,
												z.objectInputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>
											>,
											'many'
										>
									>;
								},
								z.ZodTypeAny,
								'passthrough'
							>,
							z.objectInputType<
								{
									name: z.ZodEnum<
										[
											'search_platform_layer_l1',
											'search_platform_layer_l2',
											'search_platform_layer_l3',
											'search_platform_layer_query_expansion',
										]
									>;
									analyticsDefinitions: z.ZodOptional<
										z.ZodArray<
											z.ZodObject<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												'passthrough',
												z.ZodTypeAny,
												z.objectOutputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>,
												z.objectInputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>
											>,
											'many'
										>
									>;
								},
								z.ZodTypeAny,
								'passthrough'
							>
						>,
						'many'
					>
				>;
			},
			z.ZodTypeAny,
			'passthrough'
		>,
		z.objectInputType<
			{
				sourceProduct: z.ZodOptional<z.ZodString>;
				frontendFeatureGates: z.ZodOptional<
					z.ZodArray<
						z.ZodObject<
							{
								name: z.ZodString;
								value: z.ZodBoolean;
							},
							'strip',
							z.ZodTypeAny,
							{
								name: string;
								value: boolean;
							},
							{
								name: string;
								value: boolean;
							}
						>,
						'many'
					>
				>;
				frontendExperiments: z.ZodOptional<
					z.ZodArray<
						z.ZodObject<
							{
								name: z.ZodString;
								value: z.ZodRecord<z.ZodString, z.ZodUnion<[z.ZodString, z.ZodBoolean]>>;
							},
							'strip',
							z.ZodTypeAny,
							{
								name: string;
								value: Record<string, string | boolean>;
							},
							{
								name: string;
								value: Record<string, string | boolean>;
							}
						>,
						'many'
					>
				>;
				backendExperiments: z.ZodOptional<
					z.ZodArray<
						z.ZodObject<
							{
								name: z.ZodEnum<
									[
										'search_platform_layer_l1',
										'search_platform_layer_l2',
										'search_platform_layer_l3',
										'search_platform_layer_query_expansion',
									]
								>;
								analyticsDefinitions: z.ZodOptional<
									z.ZodArray<
										z.ZodObject<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											'passthrough',
											z.ZodTypeAny,
											z.objectOutputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>,
											z.objectInputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>
										>,
										'many'
									>
								>;
							},
							'passthrough',
							z.ZodTypeAny,
							z.objectOutputType<
								{
									name: z.ZodEnum<
										[
											'search_platform_layer_l1',
											'search_platform_layer_l2',
											'search_platform_layer_l3',
											'search_platform_layer_query_expansion',
										]
									>;
									analyticsDefinitions: z.ZodOptional<
										z.ZodArray<
											z.ZodObject<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												'passthrough',
												z.ZodTypeAny,
												z.objectOutputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>,
												z.objectInputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>
											>,
											'many'
										>
									>;
								},
								z.ZodTypeAny,
								'passthrough'
							>,
							z.objectInputType<
								{
									name: z.ZodEnum<
										[
											'search_platform_layer_l1',
											'search_platform_layer_l2',
											'search_platform_layer_l3',
											'search_platform_layer_query_expansion',
										]
									>;
									analyticsDefinitions: z.ZodOptional<
										z.ZodArray<
											z.ZodObject<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												'passthrough',
												z.ZodTypeAny,
												z.objectOutputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>,
												z.objectInputType<
													{
														layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														abTestId: z.ZodNullable<z.ZodString>;
														armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
														controlId: z.ZodNullable<z.ZodString>;
													},
													z.ZodTypeAny,
													'passthrough'
												>
											>,
											'many'
										>
									>;
								},
								z.ZodTypeAny,
								'passthrough'
							>
						>,
						'many'
					>
				>;
			},
			z.ZodTypeAny,
			'passthrough'
		>
	>,
	z.objectOutputType<
		{
			sourceProduct: z.ZodOptional<z.ZodString>;
			frontendFeatureGates: z.ZodOptional<
				z.ZodArray<
					z.ZodObject<
						{
							name: z.ZodString;
							value: z.ZodBoolean;
						},
						'strip',
						z.ZodTypeAny,
						{
							name: string;
							value: boolean;
						},
						{
							name: string;
							value: boolean;
						}
					>,
					'many'
				>
			>;
			frontendExperiments: z.ZodOptional<
				z.ZodArray<
					z.ZodObject<
						{
							name: z.ZodString;
							value: z.ZodRecord<z.ZodString, z.ZodUnion<[z.ZodString, z.ZodBoolean]>>;
						},
						'strip',
						z.ZodTypeAny,
						{
							name: string;
							value: Record<string, string | boolean>;
						},
						{
							name: string;
							value: Record<string, string | boolean>;
						}
					>,
					'many'
				>
			>;
			backendExperiments: z.ZodOptional<
				z.ZodArray<
					z.ZodObject<
						{
							name: z.ZodEnum<
								[
									'search_platform_layer_l1',
									'search_platform_layer_l2',
									'search_platform_layer_l3',
									'search_platform_layer_query_expansion',
								]
							>;
							analyticsDefinitions: z.ZodOptional<
								z.ZodArray<
									z.ZodObject<
										{
											layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											abTestId: z.ZodNullable<z.ZodString>;
											armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
											controlId: z.ZodNullable<z.ZodString>;
										},
										'passthrough',
										z.ZodTypeAny,
										z.objectOutputType<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											z.ZodTypeAny,
											'passthrough'
										>,
										z.objectInputType<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											z.ZodTypeAny,
											'passthrough'
										>
									>,
									'many'
								>
							>;
						},
						'passthrough',
						z.ZodTypeAny,
						z.objectOutputType<
							{
								name: z.ZodEnum<
									[
										'search_platform_layer_l1',
										'search_platform_layer_l2',
										'search_platform_layer_l3',
										'search_platform_layer_query_expansion',
									]
								>;
								analyticsDefinitions: z.ZodOptional<
									z.ZodArray<
										z.ZodObject<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											'passthrough',
											z.ZodTypeAny,
											z.objectOutputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>,
											z.objectInputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>
										>,
										'many'
									>
								>;
							},
							z.ZodTypeAny,
							'passthrough'
						>,
						z.objectInputType<
							{
								name: z.ZodEnum<
									[
										'search_platform_layer_l1',
										'search_platform_layer_l2',
										'search_platform_layer_l3',
										'search_platform_layer_query_expansion',
									]
								>;
								analyticsDefinitions: z.ZodOptional<
									z.ZodArray<
										z.ZodObject<
											{
												layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												abTestId: z.ZodNullable<z.ZodString>;
												armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
												controlId: z.ZodNullable<z.ZodString>;
											},
											'passthrough',
											z.ZodTypeAny,
											z.objectOutputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>,
											z.objectInputType<
												{
													layerId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													shadowId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													entity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													subEntity: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													abTestId: z.ZodNullable<z.ZodString>;
													armId: z.ZodOptional<z.ZodNullable<z.ZodString>>;
													controlId: z.ZodNullable<z.ZodString>;
												},
												z.ZodTypeAny,
												'passthrough'
											>
										>,
										'many'
									>
								>;
							},
							z.ZodTypeAny,
							'passthrough'
						>
					>,
					'many'
				>
			>;
		},
		z.ZodTypeAny,
		'passthrough'
	>,
	unknown
> = jsonEncodedSchema(
	z
		.object({
			sourceProduct: z.string().min(1).optional(),
			frontendFeatureGates: z
				.array(
					z.object({
						name: z.string().min(1),
						value: z.boolean(),
					}),
				)
				.optional(),
			frontendExperiments: z
				.array(
					z.object({
						name: z.string().min(1),
						value: z.record(z.union([z.string(), z.boolean()])),
					}),
				)
				.optional(),
			backendExperiments: z
				.array(
					z
						.object({
							name: z.enum([
								'search_platform_layer_l1',
								'search_platform_layer_l2',
								'search_platform_layer_l3',
								'search_platform_layer_query_expansion',
							]),
							analyticsDefinitions: z
								.array(
									z
										.object({
											layerId: z.string().nullable().optional(),
											shadowId: z.string().nullable().optional(),
											entity: z.string().nullable().optional(),
											subEntity: z.string().nullable().optional(),
											abTestId: z.string().nullable(),
											armId: z.string().nullable().optional(),
											controlId: z.string().nullable(),
										})
										.passthrough(),
								)
								.optional(),
						})
						.passthrough(),
				)
				.optional(),
		})
		.passthrough(),
);

export const searchQueryParamsBaseSchema: z.ZodObject<
	{
		text: z.ZodOptional<z.ZodString>;
		originalQuery: z.ZodOptional<z.ZodString>;
		product: z.ZodOptional<
			z.ZodPipeline<
				z.ZodString,
				z.ZodUnion<
					[
						z.ZodNativeEnum<{
							readonly AtlassianWebCrawler: 'atlassian-web-crawler';
							readonly Figma: 'figma';
							readonly Github: 'github';
							readonly GoogleDrive: 'drive';
							readonly Loom: 'loom';
							readonly OneDrive: 'onedrive';
							readonly Dropbox: 'dropbox';
							readonly Slack: 'slack';
							readonly Sharepoint: 'sharepoint';
							readonly Teams: 'teams';
							readonly GoogleCalendar: 'google-calendar';
							readonly OutlookCalendar: 'outlook-calendar';
							readonly OutlookMail: 'outlook-mail';
							readonly Gmail: 'gmail';
							readonly AdobeSign: 'adobe-sign';
							readonly Asana: 'asana';
							readonly Zendesk: 'zendesk';
							readonly Airtable: 'airtable';
							readonly Smartsheet: 'smartsheet';
							readonly Notion: 'notion';
							readonly Miro: 'miro';
							readonly Docusign: 'docusign';
							readonly Lucid: 'lucid';
							readonly Monday: 'monday';
							readonly AzureDevops: 'azure-devops';
							readonly Gitlab: 'gitlab';
							readonly ConfluenceDC: 'confluence-dc';
							readonly Canva: 'canva';
							readonly Box: 'box';
							readonly Zeplin: 'zeplin';
							readonly ServiceNow: 'servicenow';
							readonly Freshservice: 'freshservice';
							readonly PowerBI: 'power-bi';
							readonly ClickUp: 'clickup';
							readonly Amplitude: 'amplitude';
							readonly Stripe: 'stripe';
							readonly AdobeXD: 'adobexd';
							readonly Aha: 'aha';
							readonly Mural: 'mural';
							readonly Webex: 'webex';
							readonly Todoist: 'todoist';
							readonly PagerDuty: 'pagerduty';
							readonly Pipedrive: 'pipedrive';
							readonly Hubspot: 'hubspot';
							readonly Dovetail: 'dovetail';
							readonly LaunchDarkly: 'launchdarkly';
							readonly Salesforce: 'salesforce';
							readonly Sentry: 'sentry';
							readonly JiraDC: 'jira-dc';
							readonly Gitbook: 'gitbook';
							readonly AWSS3: 'aws-s3';
							readonly Databricks: 'databricks';
							readonly JsmDC: 'jsm-dc';
							readonly ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector';
							readonly ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector';
							readonly ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector';
							readonly ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector';
							readonly ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector';
							readonly ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector';
							readonly ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector';
							readonly ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector';
							readonly ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector';
							readonly ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector';
							readonly ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector';
							readonly ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector';
							readonly ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector';
							readonly ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector';
							readonly ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector';
							readonly ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector';
							readonly ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector';
							readonly ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector';
							readonly ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector';
							readonly ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector';
							readonly ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector';
							readonly ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector';
							readonly ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector';
							readonly ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector';
							readonly ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector';
							readonly ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector';
							readonly ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector';
							readonly ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector';
							readonly ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector';
							readonly ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector';
							readonly ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive';
							readonly ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive';
							readonly ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce';
							readonly ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce';
							readonly ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow';
							readonly ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow';
							readonly ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike';
							readonly ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike';
							readonly ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana';
							readonly ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana';
							readonly ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp';
							readonly ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp';
							readonly Gong: 'gong';
							readonly Zoom: 'zoom';
							readonly Atlas: 'townsquare';
							readonly Bitbucket: 'bitbucket';
							readonly Compass: 'compass';
							readonly Confluence: 'confluence';
							readonly Jira: 'jira';
							readonly JiraProductDiscovery: 'jira-product-discovery';
							readonly JiraServiceManagement: 'jira-servicedesk';
							readonly Trello: 'trello';
							readonly Focus: 'mercury';
							readonly Assets: 'cmdb';
							readonly Talent: 'radar';
						}>,
						z.ZodEffects<z.ZodString, string, string>,
					]
				>
			>
		>;
		datasource: z.ZodOptional<z.ZodString>;
		type: z.ZodOptional<
			z.ZodPipeline<
				z.ZodString,
				z.ZodNativeEnum<{
					readonly All: string;
					readonly Document: 'document';
					readonly Spreadsheet: 'spreadsheet';
					readonly Presentation: 'presentation';
					readonly Repository: 'repository';
					readonly PullRequest: 'pull-request';
					readonly Branch: 'branch';
					readonly Commit: 'commit';
					readonly DevopsWorkItem: 'devops-work-item';
					readonly WebPage: 'web-page';
					readonly Conversation: 'conversation';
					readonly Message: 'message';
					readonly Video: 'video';
					readonly AsyncVideo: 'async-video';
					readonly MeetingRecording: 'meeting-recording';
					readonly Playlist: 'playlist';
					readonly Design: 'design';
					readonly Page: 'page';
					readonly Blogpost: 'blogpost';
					readonly Attachment: 'attachment';
					readonly Space: 'space';
					readonly Whiteboard: 'whiteboard';
					readonly Slide: 'slide';
					readonly Comment: 'comment';
					readonly Database: 'database';
					readonly Embed: 'embed';
					readonly Folder: 'folder';
					readonly Calendar: 'calendar';
					readonly SpaceCalendar: 'space-calendar';
					readonly Question: 'question';
					readonly Answer: 'answer';
					readonly Issue: 'issue';
					readonly Epic: 'epic';
					readonly Bug: 'bug';
					readonly Story: 'story';
					readonly Task: 'task';
					readonly Subtask: 'subtask';
					readonly Project: 'project';
					readonly Incident: 'incident';
					readonly Filter: 'filter';
					readonly Plan: 'plan';
					readonly Board: 'board';
					readonly Component: 'component';
					readonly Card: 'card';
					readonly Goal: 'goal';
					readonly Tag: 'tag';
					readonly WorkItem: 'work-item';
					readonly FocusArea: 'focus-area';
					readonly Organization: 'organization';
					readonly Ask: 'ask';
					readonly Risk: 'risk';
					readonly Dashboard: 'dashboard';
					readonly Invoice: 'invoice';
					readonly Deal: 'deal';
					readonly Gliffy: 'gliffy';
					readonly CustomerContact: 'customer-contact';
					readonly CustomerOrg: 'customer-org';
					readonly Campaign: 'campaign';
					readonly Case: 'case';
					readonly DataTable: 'data-table';
					readonly AssetsObject: 'object';
					readonly Type: 'type';
					readonly Schema: 'schema';
					readonly Position: 'position';
					readonly Image: 'image';
					readonly Audio: 'audio';
					readonly Pdf: 'pdf';
					readonly Shortcut: 'shortcut';
					readonly Code: 'code';
					readonly Archive: 'archive';
					readonly Other: 'other';
					readonly Notebook: 'notebook';
					readonly Form: 'form';
					readonly Article: 'article';
					readonly Post: 'post';
					readonly Ticket: 'ticket';
					readonly CatalogItem: 'catalog-item';
					readonly RequestedItem: 'requested-item';
					readonly Demand: 'demand';
					readonly KnowledgeArticle: 'knowledge-article';
					readonly NewsArticle: 'news-article';
					readonly Lead: 'lead';
				}>
			>
		>;
		filterDropdownOpen: z.ZodOptional<
			z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>
		>;
		lastModified: z.ZodOptional<
			z.ZodPipeline<
				z.ZodString,
				z.ZodNativeEnum<{
					readonly Anytime: 'anytime';
					readonly Today: 'today';
					readonly Yesterday: 'yesterday';
					readonly Past7Days: 'past7Days';
					readonly Past30Days: 'past30Days';
					readonly PastYear: 'pastYear';
					readonly Custom: 'custom';
				}>
			>
		>;
		lastModified_lt: z.ZodOptional<z.ZodPipeline<z.ZodString, z.ZodDate>>;
		lastModified_gt: z.ZodOptional<z.ZodPipeline<z.ZodString, z.ZodDate>>;
		sort: z.ZodOptional<
			z.ZodPipeline<
				z.ZodString,
				z.ZodNativeEnum<{
					readonly Relevance: 'relevance';
					readonly UpdatedNewest: 'updatedNewest';
					readonly UpdatedOldest: 'updatedOldest';
					readonly CreatedNewest: 'createdNewest';
					readonly CreatedOldest: 'createdOldest';
				}>
			>
		>;
		from: z.ZodOptional<z.ZodString>;
		to: z.ZodOptional<z.ZodString>;
		titleMatch: z.ZodOptional<
			z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>
		>;
		contributors: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		owners: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		ancestor: z.ZodOptional<z.ZodString>;
		campaignStatuses: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		caseStatuses: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		knowledgeArticleStatuses: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		eventTypes: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		leadStatuses: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		taskStatuses: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		taskTypes: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		isAutoApplied: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		salesforceStages: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		spaces: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		sites: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		verified: z.ZodOptional<z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>>;
		labels: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		tags: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		pageStatus: z.ZodOptional<
			z.ZodPipeline<
				z.ZodString,
				z.ZodNativeEnum<{
					All: string;
					RoughDraft: 'roughDraft';
					InProgress: 'inProgress';
					ReadyForReview: 'readyForReview';
					Verified: 'verified';
				}>
			>
		>;
		archived: z.ZodOptional<z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>>;
		jAssignee: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		jReporter: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		jCommentedByMe: z.ZodOptional<
			z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>
		>;
		jProject: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		jWatchedByMe: z.ZodOptional<
			z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>
		>;
		assetsSchema: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		assetsType: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		focusAreaTypes: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		focusAreaUnder: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		positionEmploymentTypes: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		positionFocusAreas: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		positionJobFamilies: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		positionStatuses: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		positionTeams: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		compassArchived: z.ZodOptional<
			z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>
		>;
		createdBy: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		lastUpdatedBy: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		closeDate: z.ZodOptional<z.ZodString>;
		closeDateVal: z.ZodOptional<z.ZodString>;
		opportunityStatus: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		referrer: z.ZodOptional<z.ZodString>;
		rovoJourneyId: z.ZodOptional<z.ZodString>;
		overrides: z.ZodOptional<z.ZodPipeline<z.ZodString, typeof overridesSchema>>;
		cql: z.ZodOptional<z.ZodString>;
		status: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		pullRequestStatus: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		repository: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		reviewer: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		slackChannels: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		folders: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		workspaceName: z.ZodOptional<z.ZodEffects<z.ZodString, string[], string>>;
		hasAttachment: z.ZodOptional<
			z.ZodEffects<z.ZodEnum<['true', 'false']>, boolean, 'true' | 'false'>
		>;
	},
	'strip',
	z.ZodTypeAny,
	{
		cql?: string | undefined;
		archived?: boolean | undefined;
		createdBy?: string[] | undefined;
		verified?: boolean | undefined;
		focusAreaUnder?: string[] | undefined;
		pageStatus?: string | undefined;
		lastUpdatedBy?: string[] | undefined;
		closeDate?: string | undefined;
		closeDateVal?: string | undefined;
		opportunityStatus?: string[] | undefined;
		compassArchived?: boolean | undefined;
		assetsSchema?: string[] | undefined;
		assetsType?: string[] | undefined;
		type?: string | undefined;
		text?: string | undefined;
		from?: string | undefined;
		to?: string | undefined;
		status?: string[] | undefined;
		spaces?: string[] | undefined;
		sites?: string[] | undefined;
		product?: string | undefined;
		originalQuery?: string | undefined;
		datasource?: string | undefined;
		filterDropdownOpen?: boolean | undefined;
		lastModified?:
			| 'custom'
			| 'anytime'
			| 'today'
			| 'yesterday'
			| 'past7Days'
			| 'past30Days'
			| 'pastYear'
			| undefined;
		lastModified_lt?: Date | undefined;
		lastModified_gt?: Date | undefined;
		sort?:
			| 'relevance'
			| 'updatedNewest'
			| 'updatedOldest'
			| 'createdNewest'
			| 'createdOldest'
			| undefined;
		titleMatch?: boolean | undefined;
		contributors?: string[] | undefined;
		owners?: string[] | undefined;
		ancestor?: string | undefined;
		campaignStatuses?: string[] | undefined;
		caseStatuses?: string[] | undefined;
		knowledgeArticleStatuses?: string[] | undefined;
		eventTypes?: string[] | undefined;
		leadStatuses?: string[] | undefined;
		taskStatuses?: string[] | undefined;
		taskTypes?: string[] | undefined;
		isAutoApplied?: string[] | undefined;
		salesforceStages?: string[] | undefined;
		labels?: string[] | undefined;
		tags?: string[] | undefined;
		jAssignee?: string[] | undefined;
		jReporter?: string[] | undefined;
		jCommentedByMe?: boolean | undefined;
		jProject?: string[] | undefined;
		jWatchedByMe?: boolean | undefined;
		focusAreaTypes?: string[] | undefined;
		positionEmploymentTypes?: string[] | undefined;
		positionFocusAreas?: string[] | undefined;
		positionJobFamilies?: string[] | undefined;
		positionStatuses?: string[] | undefined;
		positionTeams?: string[] | undefined;
		referrer?: string | undefined;
		rovoJourneyId?: string | undefined;
		pullRequestStatus?: string[] | undefined;
		repository?: string[] | undefined;
		reviewer?: string[] | undefined;
		slackChannels?: string[] | undefined;
		folders?: string[] | undefined;
		workspaceName?: string[] | undefined;
		hasAttachment?: boolean | undefined;
		overrides?: Overrides;
	},
	{
		cql?: string | undefined;
		archived?: 'true' | 'false' | undefined;
		createdBy?: string | undefined;
		verified?: 'true' | 'false' | undefined;
		focusAreaUnder?: string | undefined;
		pageStatus?: string | undefined;
		lastUpdatedBy?: string | undefined;
		closeDate?: string | undefined;
		closeDateVal?: string | undefined;
		opportunityStatus?: string | undefined;
		compassArchived?: 'true' | 'false' | undefined;
		assetsSchema?: string | undefined;
		assetsType?: string | undefined;
		type?: string | undefined;
		text?: string | undefined;
		from?: string | undefined;
		to?: string | undefined;
		status?: string | undefined;
		spaces?: string | undefined;
		sites?: string | undefined;
		product?: string | undefined;
		originalQuery?: string | undefined;
		datasource?: string | undefined;
		filterDropdownOpen?: 'true' | 'false' | undefined;
		lastModified?: string | undefined;
		lastModified_lt?: string | undefined;
		lastModified_gt?: string | undefined;
		sort?: string | undefined;
		titleMatch?: 'true' | 'false' | undefined;
		contributors?: string | undefined;
		owners?: string | undefined;
		ancestor?: string | undefined;
		campaignStatuses?: string | undefined;
		caseStatuses?: string | undefined;
		knowledgeArticleStatuses?: string | undefined;
		eventTypes?: string | undefined;
		leadStatuses?: string | undefined;
		taskStatuses?: string | undefined;
		taskTypes?: string | undefined;
		isAutoApplied?: string | undefined;
		salesforceStages?: string | undefined;
		labels?: string | undefined;
		tags?: string | undefined;
		jAssignee?: string | undefined;
		jReporter?: string | undefined;
		jCommentedByMe?: 'true' | 'false' | undefined;
		jProject?: string | undefined;
		jWatchedByMe?: 'true' | 'false' | undefined;
		focusAreaTypes?: string | undefined;
		positionEmploymentTypes?: string | undefined;
		positionFocusAreas?: string | undefined;
		positionJobFamilies?: string | undefined;
		positionStatuses?: string | undefined;
		positionTeams?: string | undefined;
		referrer?: string | undefined;
		rovoJourneyId?: string | undefined;
		overrides?: string | undefined;
		pullRequestStatus?: string | undefined;
		repository?: string | undefined;
		reviewer?: string | undefined;
		slackChannels?: string | undefined;
		folders?: string | undefined;
		workspaceName?: string | undefined;
		hasAttachment?: 'true' | 'false' | undefined;
	}
> = z.object({
	text: z.optional(z.string().max(200)), // TODO: >>>> Ask how long should be the max query string?
	originalQuery: z.optional(z.string().max(200)), // Used to support "Did you mean" feature
	product: z.optional(z.string().pipe(productKeySchema)),
	datasource: z.optional(z.string()),
	type: z.optional(z.string().pipe(contentTypeSchema)),
	filterDropdownOpen: z.optional(booleanSchema),

	// Last Modified
	lastModified: z.optional(z.string().pipe(lastModifiedValueSchema)),
	lastModified_lt: z.optional(z.string().pipe(z.coerce.date())),
	lastModified_gt: z.optional(z.string().pipe(z.coerce.date())),
	from: z.optional(z.string()),
	to: z.optional(z.string()),

	sort: z.optional(z.string().pipe(sortSchema)),

	titleMatch: z.optional(booleanSchema),

	// Confluence filters
	contributors: z.optional(commaSeparatedArraySchema),
	owners: z.optional(commaSeparatedArraySchema),
	ancestor: z.optional(z.string()),

	// Salesforce Filters
	campaignStatuses: z.optional(commaSeparatedArraySchema),
	caseStatuses: z.optional(commaSeparatedArraySchema),
	knowledgeArticleStatuses: z.optional(commaSeparatedArraySchema),
	eventTypes: z.optional(commaSeparatedArraySchema),
	leadStatuses: z.optional(commaSeparatedArraySchema),
	taskStatuses: z.optional(commaSeparatedArraySchema),
	taskTypes: z.optional(commaSeparatedArraySchema),
	isAutoApplied: z.optional(commaSeparatedArraySchema),
	salesforceStages: z.optional(commaSeparatedArraySchema),
	spaces: z.optional(commaSeparatedArraySchema),
	sites: z.optional(commaSeparatedArraySchema),
	verified: z.optional(booleanSchema),
	labels: z.optional(commaSeparatedArraySchema),
	tags: z.optional(commaSeparatedArraySchema),
	pageStatus: z.optional(z.string().pipe(pageStatusSchema)),
	archived: z.optional(booleanSchema),

	// Jira Filters
	jAssignee: z.optional(commaSeparatedArraySchema),
	jReporter: z.optional(commaSeparatedArraySchema),
	jCommentedByMe: z.optional(booleanSchema),
	jProject: z.optional(commaSeparatedArraySchema),
	jWatchedByMe: z.optional(booleanSchema),

	// Assets Filters
	assetsSchema: z.optional(commaSeparatedArraySchema),
	assetsType: z.optional(commaSeparatedArraySchema),

	// Mercury Filters
	focusAreaTypes: z.optional(commaSeparatedArraySchema),
	focusAreaUnder: z.optional(commaSeparatedArraySchema),

	// Talent Filters
	positionEmploymentTypes: z.optional(commaSeparatedArraySchema),
	positionFocusAreas: z.optional(commaSeparatedArraySchema),
	positionJobFamilies: z.optional(commaSeparatedArraySchema),
	positionStatuses: z.optional(commaSeparatedArraySchema),
	positionTeams: z.optional(commaSeparatedArraySchema),

	// Compass Filters
	compassArchived: z.optional(booleanSchema),

	createdBy: z.optional(commaSeparatedArraySchema),

	lastUpdatedBy: z.optional(commaSeparatedArraySchema),

	// Salesforce Close Date filter
	closeDate: z.optional(z.string()),
	closeDateVal: z.optional(z.string()),

	// Salesforce Opportunity Status filter
	opportunityStatus: z.optional(commaSeparatedArraySchema),

	referrer: z.optional(z.string()),

	/**
	 * Quick Find chat-convergence routing decision that sent the user to this search, when there was
	 * one. Read once on bootstrap and passed down to Search AI answers, which surfaces it on
	 * `aiResult viewed` (QS-10491).
	 */
	rovoJourneyId: z.optional(z.string()),

	/**
	 * URL encoded JSON string used to override feature gates/experiments for debugging.
	 */
	overrides: z.optional(z.string().pipe(overridesSchema)),

	cql: z.optional(z.string()),

	status: z.optional(commaSeparatedArraySchema),

	// Pull Request Status filter (GitHub, Bitbucket, GitLab)
	pullRequestStatus: z.optional(commaSeparatedArraySchema),
	// Repository filter (GitHub)
	repository: z.optional(commaSeparatedArraySchema),
	// Reviewer filter (GitHub)
	reviewer: z.optional(commaSeparatedArraySchema),
	// Slack Channel filter
	slackChannels: z.optional(commaSeparatedArraySchema),
	// Loom folder filter (Quick Find, multi-select)
	folders: z.optional(commaSeparatedArraySchema),
	// MS Teams Team (workspace) filter
	workspaceName: z.optional(commaSeparatedArraySchema),
	// MS Teams Has Attachment filter
	hasAttachment: z.optional(booleanSchema),
});

export type SearchQueryStringParams = z.infer<typeof searchQueryParamsBaseSchema>;
export const SearchQueryStringParamKey: z.Values<
	[
		'cql',
		'archived',
		'createdBy',
		'verified',
		'focusAreaUnder',
		'pageStatus',
		'lastUpdatedBy',
		'compassArchived',
		'assetsSchema',
		'assetsType',
		'type',
		'text',
		'from',
		'to',
		'status',
		'spaces',
		'sites',
		'product',
		'originalQuery',
		'datasource',
		'filterDropdownOpen',
		'sort',
		'lastModified',
		'lastModified_lt',
		'lastModified_gt',
		'titleMatch',
		'contributors',
		'owners',
		'ancestor',
		'campaignStatuses',
		'caseStatuses',
		'knowledgeArticleStatuses',
		'eventTypes',
		'leadStatuses',
		'taskStatuses',
		'taskTypes',
		'isAutoApplied',
		'salesforceStages',
		'labels',
		'tags',
		'jAssignee',
		'jReporter',
		'jCommentedByMe',
		'jProject',
		'jWatchedByMe',
		'focusAreaTypes',
		'positionEmploymentTypes',
		'positionFocusAreas',
		'positionJobFamilies',
		'positionStatuses',
		'positionTeams',
		'closeDate',
		'closeDateVal',
		'opportunityStatus',
		'pullRequestStatus',
		'repository',
		'reviewer',
		'slackChannels',
		'folders',
		'workspaceName',
		'hasAttachment',
		'referrer',
		'rovoJourneyId',
		'overrides',
	]
> = searchQueryParamsBaseSchema.keyof().enum;
export type SearchQueryStringParamKeys = keyof SearchQueryStringParams;
export type SearchQueryStringParamsRaw = z.input<typeof searchQueryParamsBaseSchema>;
type ExtractKeysWithArrayValues<T> = {
	[P in keyof T]: T[P] extends unknown[] ? P : never;
}[keyof T];
export type SearchQueryStringParamKeysWithValues = NonNullable<
	ExtractKeysWithArrayValues<SearchQueryStringParams>
>;

export const searchQueryParamsValidators: ((
	queryParams: SearchQueryStringParams,
) => SearchQueryStringParams)[] = [
	(queryParams) => {
		if (queryParams.lastModified !== 'custom') {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { lastModified_gt, lastModified_lt, ...restQueryParams } = queryParams;
			return restQueryParams;
		}
		return queryParams;
	},
	(queryParams) => {
		const { lastModified_lt, lastModified_gt } = queryParams;
		if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
			const {
				lastModified: _,
				lastModified_gt: __,
				lastModified_lt: ___,
				...restQueryParams
			} = queryParams;
			return restQueryParams;
		}
		return queryParams;
	},
	// If closeDate is not 'custom', strip out closeDateVal
	(queryParams) => {
		if (queryParams.closeDate !== 'custom') {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { closeDateVal, ...restQueryParams } = queryParams;
			return restQueryParams;
		}
		return queryParams;
	},
] satisfies ((queryParams: SearchQueryStringParams) => SearchQueryStringParams)[];

export const filterKeysSchema: z.ZodNativeEnum<{
	readonly eventTypes: 'eventTypes';
	readonly leadStatuses: 'leadStatuses';
	readonly taskStatuses: 'taskStatuses';
	readonly taskTypes: 'taskTypes';
	readonly cql: 'cql';
	readonly archived: 'archived';
	readonly createdBy: 'createdBy';
	readonly verified: 'verified';
	readonly focusAreaUnder: 'focusAreaUnder';
	readonly pageStatus: 'pageStatus';
	readonly lastUpdatedBy: 'lastUpdatedBy';
	readonly compassArchived: 'compassArchived';
	readonly assetsSchema: 'assetsSchema';
	readonly assetsType: 'assetsType';
	readonly type: 'type';
	readonly text: 'text';
	readonly from: 'from';
	readonly to: 'to';
	readonly status: 'status';
	readonly spaces: 'spaces';
	readonly sites: 'sites';
	readonly product: 'product';
	readonly originalQuery: 'originalQuery';
	readonly datasource: 'datasource';
	readonly filterDropdownOpen: 'filterDropdownOpen';
	readonly lastModified: 'lastModified';
	readonly lastModified_lt: 'lastModified_lt';
	readonly lastModified_gt: 'lastModified_gt';
	readonly sort: 'sort';
	readonly titleMatch: 'titleMatch';
	readonly contributors: 'contributors';
	readonly owners: 'owners';
	readonly ancestor: 'ancestor';
	readonly campaignStatuses: 'campaignStatuses';
	readonly caseStatuses: 'caseStatuses';
	readonly knowledgeArticleStatuses: 'knowledgeArticleStatuses';
	readonly isAutoApplied: 'isAutoApplied';
	readonly salesforceStages: 'salesforceStages';
	readonly labels: 'labels';
	readonly tags: 'tags';
	readonly jAssignee: 'jAssignee';
	readonly jReporter: 'jReporter';
	readonly jCommentedByMe: 'jCommentedByMe';
	readonly jProject: 'jProject';
	readonly jWatchedByMe: 'jWatchedByMe';
	readonly focusAreaTypes: 'focusAreaTypes';
	readonly positionEmploymentTypes: 'positionEmploymentTypes';
	readonly positionFocusAreas: 'positionFocusAreas';
	readonly positionJobFamilies: 'positionJobFamilies';
	readonly positionStatuses: 'positionStatuses';
	readonly positionTeams: 'positionTeams';
	readonly closeDate: 'closeDate';
	readonly closeDateVal: 'closeDateVal';
	readonly opportunityStatus: 'opportunityStatus';
	readonly pullRequestStatus: 'pullRequestStatus';
	readonly repository: 'repository';
	readonly reviewer: 'reviewer';
	readonly slackChannels: 'slackChannels';
	readonly folders: 'folders';
	readonly workspaceName: 'workspaceName';
	readonly hasAttachment: 'hasAttachment';
	readonly referrer: 'referrer';
	readonly rovoJourneyId: 'rovoJourneyId';
	readonly overrides: 'overrides';
	readonly Anytime: 'anytime';
	readonly Today: 'today';
	readonly Yesterday: 'yesterday';
	readonly Past7Days: 'past7Days';
	readonly Past30Days: 'past30Days';
	readonly PastYear: 'pastYear';
	readonly Custom: 'custom';
	readonly All: string;
	readonly Document: 'document';
	readonly Spreadsheet: 'spreadsheet';
	readonly Presentation: 'presentation';
	readonly Repository: 'repository';
	readonly PullRequest: 'pull-request';
	readonly Branch: 'branch';
	readonly Commit: 'commit';
	readonly DevopsWorkItem: 'devops-work-item';
	readonly WebPage: 'web-page';
	readonly Conversation: 'conversation';
	readonly Message: 'message';
	readonly Video: 'video';
	readonly AsyncVideo: 'async-video';
	readonly MeetingRecording: 'meeting-recording';
	readonly Playlist: 'playlist';
	readonly Design: 'design';
	readonly Page: 'page';
	readonly Blogpost: 'blogpost';
	readonly Attachment: 'attachment';
	readonly Space: 'space';
	readonly Whiteboard: 'whiteboard';
	readonly Slide: 'slide';
	readonly Comment: 'comment';
	readonly Database: 'database';
	readonly Embed: 'embed';
	readonly Folder: 'folder';
	readonly Calendar: 'calendar';
	readonly SpaceCalendar: 'space-calendar';
	readonly Question: 'question';
	readonly Answer: 'answer';
	readonly Issue: 'issue';
	readonly Epic: 'epic';
	readonly Bug: 'bug';
	readonly Story: 'story';
	readonly Task: 'task';
	readonly Subtask: 'subtask';
	readonly Project: 'project';
	readonly Incident: 'incident';
	readonly Filter: 'filter';
	readonly Plan: 'plan';
	readonly Board: 'board';
	readonly Component: 'component';
	readonly Card: 'card';
	readonly Goal: 'goal';
	readonly Tag: 'tag';
	readonly WorkItem: 'work-item';
	readonly FocusArea: 'focus-area';
	readonly Organization: 'organization';
	readonly Ask: 'ask';
	readonly Risk: 'risk';
	readonly Dashboard: 'dashboard';
	readonly Invoice: 'invoice';
	readonly Deal: 'deal';
	readonly Gliffy: 'gliffy';
	readonly CustomerContact: 'customer-contact';
	readonly CustomerOrg: 'customer-org';
	readonly Campaign: 'campaign';
	readonly Case: 'case';
	readonly DataTable: 'data-table';
	readonly AssetsObject: 'object';
	readonly Type: 'type';
	readonly Schema: 'schema';
	readonly Position: 'position';
	readonly Image: 'image';
	readonly Audio: 'audio';
	readonly Pdf: 'pdf';
	readonly Shortcut: 'shortcut';
	readonly Code: 'code';
	readonly Archive: 'archive';
	readonly Other: 'other';
	readonly Notebook: 'notebook';
	readonly Form: 'form';
	readonly Article: 'article';
	readonly Post: 'post';
	readonly Ticket: 'ticket';
	readonly CatalogItem: 'catalog-item';
	readonly RequestedItem: 'requested-item';
	readonly Demand: 'demand';
	readonly KnowledgeArticle: 'knowledge-article';
	readonly NewsArticle: 'news-article';
	readonly Lead: 'lead';
	readonly AtlassianWebCrawler: 'atlassian-web-crawler';
	readonly Figma: 'figma';
	readonly Github: 'github';
	readonly GoogleDrive: 'drive';
	readonly Loom: 'loom';
	readonly OneDrive: 'onedrive';
	readonly Dropbox: 'dropbox';
	readonly Slack: 'slack';
	readonly Sharepoint: 'sharepoint';
	readonly Teams: 'teams';
	readonly GoogleCalendar: 'google-calendar';
	readonly OutlookCalendar: 'outlook-calendar';
	readonly OutlookMail: 'outlook-mail';
	readonly Gmail: 'gmail';
	readonly AdobeSign: 'adobe-sign';
	readonly Asana: 'asana';
	readonly Zendesk: 'zendesk';
	readonly Airtable: 'airtable';
	readonly Smartsheet: 'smartsheet';
	readonly Notion: 'notion';
	readonly Miro: 'miro';
	readonly Docusign: 'docusign';
	readonly Lucid: 'lucid';
	readonly Monday: 'monday';
	readonly AzureDevops: 'azure-devops';
	readonly Gitlab: 'gitlab';
	readonly ConfluenceDC: 'confluence-dc';
	readonly Canva: 'canva';
	readonly Box: 'box';
	readonly Zeplin: 'zeplin';
	readonly ServiceNow: 'servicenow';
	readonly Freshservice: 'freshservice';
	readonly PowerBI: 'power-bi';
	readonly ClickUp: 'clickup';
	readonly Amplitude: 'amplitude';
	readonly Stripe: 'stripe';
	readonly AdobeXD: 'adobexd';
	readonly Aha: 'aha';
	readonly Mural: 'mural';
	readonly Webex: 'webex';
	readonly Todoist: 'todoist';
	readonly PagerDuty: 'pagerduty';
	readonly Pipedrive: 'pipedrive';
	readonly Hubspot: 'hubspot';
	readonly Dovetail: 'dovetail';
	readonly LaunchDarkly: 'launchdarkly';
	readonly Salesforce: 'salesforce';
	readonly Sentry: 'sentry';
	readonly JiraDC: 'jira-dc';
	readonly Gitbook: 'gitbook';
	readonly AWSS3: 'aws-s3';
	readonly Databricks: 'databricks';
	readonly JsmDC: 'jsm-dc';
	readonly ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector';
	readonly ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector';
	readonly ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector';
	readonly ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector';
	readonly ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector';
	readonly ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector';
	readonly ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector';
	readonly ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector';
	readonly ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector';
	readonly ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector';
	readonly ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector';
	readonly ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector';
	readonly ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector';
	readonly ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector';
	readonly ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector';
	readonly ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector';
	readonly ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector';
	readonly ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector';
	readonly ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector';
	readonly ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector';
	readonly ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector';
	readonly ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector';
	readonly ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector';
	readonly ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector';
	readonly ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector';
	readonly ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector';
	readonly ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector';
	readonly ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector';
	readonly ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector';
	readonly ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector';
	readonly ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive';
	readonly ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive';
	readonly ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce';
	readonly ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce';
	readonly ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow';
	readonly ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow';
	readonly ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike';
	readonly ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike';
	readonly ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana';
	readonly ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana';
	readonly ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp';
	readonly ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp';
	readonly Gong: 'gong';
	readonly Zoom: 'zoom';
	readonly Atlas: 'townsquare';
	readonly Bitbucket: 'bitbucket';
	readonly Compass: 'compass';
	readonly Confluence: 'confluence';
	readonly Jira: 'jira';
	readonly JiraProductDiscovery: 'jira-product-discovery';
	readonly JiraServiceManagement: 'jira-servicedesk';
	readonly Trello: 'trello';
	readonly Focus: 'mercury';
	readonly Assets: 'cmdb';
	readonly Talent: 'radar';
}> = z.nativeEnum({
	...ProductKey,
	...ContentType,
	...LastModified,
	...SearchQueryStringParamKey,
} as const);
export const FilterKey: {
	readonly eventTypes: 'eventTypes';
	readonly leadStatuses: 'leadStatuses';
	readonly taskStatuses: 'taskStatuses';
	readonly taskTypes: 'taskTypes';
	readonly cql: 'cql';
	readonly archived: 'archived';
	readonly createdBy: 'createdBy';
	readonly verified: 'verified';
	readonly focusAreaUnder: 'focusAreaUnder';
	readonly pageStatus: 'pageStatus';
	readonly lastUpdatedBy: 'lastUpdatedBy';
	readonly compassArchived: 'compassArchived';
	readonly assetsSchema: 'assetsSchema';
	readonly assetsType: 'assetsType';
	readonly type: 'type';
	readonly text: 'text';
	readonly from: 'from';
	readonly to: 'to';
	readonly status: 'status';
	readonly spaces: 'spaces';
	readonly sites: 'sites';
	readonly product: 'product';
	readonly originalQuery: 'originalQuery';
	readonly datasource: 'datasource';
	readonly filterDropdownOpen: 'filterDropdownOpen';
	readonly lastModified: 'lastModified';
	readonly lastModified_lt: 'lastModified_lt';
	readonly lastModified_gt: 'lastModified_gt';
	readonly sort: 'sort';
	readonly titleMatch: 'titleMatch';
	readonly contributors: 'contributors';
	readonly owners: 'owners';
	readonly ancestor: 'ancestor';
	readonly campaignStatuses: 'campaignStatuses';
	readonly caseStatuses: 'caseStatuses';
	readonly knowledgeArticleStatuses: 'knowledgeArticleStatuses';
	readonly isAutoApplied: 'isAutoApplied';
	readonly salesforceStages: 'salesforceStages';
	readonly labels: 'labels';
	readonly tags: 'tags';
	readonly jAssignee: 'jAssignee';
	readonly jReporter: 'jReporter';
	readonly jCommentedByMe: 'jCommentedByMe';
	readonly jProject: 'jProject';
	readonly jWatchedByMe: 'jWatchedByMe';
	readonly focusAreaTypes: 'focusAreaTypes';
	readonly positionEmploymentTypes: 'positionEmploymentTypes';
	readonly positionFocusAreas: 'positionFocusAreas';
	readonly positionJobFamilies: 'positionJobFamilies';
	readonly positionStatuses: 'positionStatuses';
	readonly positionTeams: 'positionTeams';
	readonly closeDate: 'closeDate';
	readonly closeDateVal: 'closeDateVal';
	readonly opportunityStatus: 'opportunityStatus';
	readonly hasAttachment: 'hasAttachment';
	readonly referrer: 'referrer';
	readonly rovoJourneyId: 'rovoJourneyId';
	readonly overrides: 'overrides';
	readonly Anytime: 'anytime';
	readonly Today: 'today';
	readonly Yesterday: 'yesterday';
	readonly Past7Days: 'past7Days';
	readonly Past30Days: 'past30Days';
	readonly PastYear: 'pastYear';
	readonly Custom: 'custom';
	readonly All: string;
	readonly Document: 'document';
	readonly Spreadsheet: 'spreadsheet';
	readonly Presentation: 'presentation';
	readonly Repository: 'repository';
	readonly PullRequest: 'pull-request';
	readonly Branch: 'branch';
	readonly Commit: 'commit';
	readonly WebPage: 'web-page';
	readonly Conversation: 'conversation';
	readonly Message: 'message';
	readonly Video: 'video';
	readonly AsyncVideo: 'async-video';
	readonly MeetingRecording: 'meeting-recording';
	readonly Playlist: 'playlist';
	readonly Design: 'design';
	readonly Page: 'page';
	readonly Blogpost: 'blogpost';
	readonly Attachment: 'attachment';
	readonly Space: 'space';
	readonly Whiteboard: 'whiteboard';
	readonly Slide: 'slide';
	readonly Comment: 'comment';
	readonly Database: 'database';
	readonly Embed: 'embed';
	readonly Folder: 'folder';
	readonly Calendar: 'calendar';
	readonly SpaceCalendar: 'space-calendar';
	readonly Question: 'question';
	readonly Answer: 'answer';
	readonly Issue: 'issue';
	readonly Epic: 'epic';
	readonly Bug: 'bug';
	readonly Story: 'story';
	readonly Task: 'task';
	readonly Subtask: 'subtask';
	readonly Project: 'project';
	readonly Incident: 'incident';
	readonly Filter: 'filter';
	readonly Plan: 'plan';
	readonly Board: 'board';
	readonly Component: 'component';
	readonly Card: 'card';
	readonly Goal: 'goal';
	readonly Tag: 'tag';
	readonly WorkItem: 'work-item';
	readonly FocusArea: 'focus-area';
	readonly Ask: 'ask';
	readonly Risk: 'risk';
	readonly Dashboard: 'dashboard';
	readonly Invoice: 'invoice';
	readonly Deal: 'deal';
	readonly Gliffy: 'gliffy';
	readonly CustomerContact: 'customer-contact';
	readonly CustomerOrg: 'customer-org';
	readonly Campaign: 'campaign';
	readonly Case: 'case';
	readonly DataTable: 'data-table';
	readonly AssetsObject: 'object';
	readonly Type: 'type';
	readonly Schema: 'schema';
	readonly Position: 'position';
	readonly Image: 'image';
	readonly Audio: 'audio';
	readonly Pdf: 'pdf';
	readonly Shortcut: 'shortcut';
	readonly Code: 'code';
	readonly Archive: 'archive';
	readonly Other: 'other';
	readonly Notebook: 'notebook';
	readonly Form: 'form';
	readonly Article: 'article';
	readonly Post: 'post';
	readonly Ticket: 'ticket';
	readonly CatalogItem: 'catalog-item';
	readonly RequestedItem: 'requested-item';
	readonly Demand: 'demand';
	readonly KnowledgeArticle: 'knowledge-article';
	readonly NewsArticle: 'news-article';
	readonly AtlassianWebCrawler: 'atlassian-web-crawler';
	readonly Figma: 'figma';
	readonly Github: 'github';
	readonly GoogleDrive: 'drive';
	readonly Loom: 'loom';
	readonly OneDrive: 'onedrive';
	readonly Dropbox: 'dropbox';
	readonly Slack: 'slack';
	readonly Sharepoint: 'sharepoint';
	readonly Teams: 'teams';
	readonly GoogleCalendar: 'google-calendar';
	readonly OutlookCalendar: 'outlook-calendar';
	readonly OutlookMail: 'outlook-mail';
	readonly Gmail: 'gmail';
	readonly AdobeSign: 'adobe-sign';
	readonly Asana: 'asana';
	readonly Zendesk: 'zendesk';
	readonly Airtable: 'airtable';
	readonly Smartsheet: 'smartsheet';
	readonly Notion: 'notion';
	readonly Miro: 'miro';
	readonly Docusign: 'docusign';
	readonly Lucid: 'lucid';
	readonly Monday: 'monday';
	readonly AzureDevops: 'azure-devops';
	readonly Gitlab: 'gitlab';
	readonly ConfluenceDC: 'confluence-dc';
	readonly Canva: 'canva';
	readonly Box: 'box';
	readonly Zeplin: 'zeplin';
	readonly ServiceNow: 'servicenow';
	readonly Freshservice: 'freshservice';
	readonly PowerBI: 'power-bi';
	readonly ClickUp: 'clickup';
	readonly Amplitude: 'amplitude';
	readonly Stripe: 'stripe';
	readonly AdobeXD: 'adobexd';
	readonly Aha: 'aha';
	readonly Mural: 'mural';
	readonly Webex: 'webex';
	readonly Todoist: 'todoist';
	readonly PagerDuty: 'pagerduty';
	readonly Pipedrive: 'pipedrive';
	readonly Hubspot: 'hubspot';
	readonly Dovetail: 'dovetail';
	readonly LaunchDarkly: 'launchdarkly';
	readonly Salesforce: 'salesforce';
	readonly Sentry: 'sentry';
	readonly JiraDC: 'jira-dc';
	readonly Gitbook: 'gitbook';
	readonly AWSS3: 'aws-s3';
	readonly Databricks: 'databricks';
	readonly JsmDC: 'jsm-dc';
	readonly ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector';
	readonly ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector';
	readonly ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector';
	readonly ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector';
	readonly ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector';
	readonly ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector';
	readonly ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector';
	readonly ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector';
	readonly ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector';
	readonly ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector';
	readonly ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector';
	readonly ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector';
	readonly ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector';
	readonly ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector';
	readonly ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector';
	readonly ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector';
	readonly ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector';
	readonly ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector';
	readonly ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector';
	readonly ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector';
	readonly ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector';
	readonly ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector';
	readonly ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector';
	readonly ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector';
	readonly ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector';
	readonly ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector';
	readonly ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector';
	readonly ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector';
	readonly ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector';
	readonly ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector';
	readonly ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive';
	readonly ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive';
	readonly ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce';
	readonly ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce';
	readonly ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow';
	readonly ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow';
	readonly ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike';
	readonly ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike';
	readonly ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana';
	readonly ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana';
	readonly ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp';
	readonly ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp';
	readonly Gong: 'gong';
	readonly Zoom: 'zoom';
	readonly Atlas: 'townsquare';
	readonly Bitbucket: 'bitbucket';
	readonly Compass: 'compass';
	readonly Confluence: 'confluence';
	readonly Jira: 'jira';
	readonly JiraProductDiscovery: 'jira-product-discovery';
	readonly JiraServiceManagement: 'jira-servicedesk';
	readonly Trello: 'trello';
	readonly Focus: 'mercury';
	readonly Assets: 'cmdb';
	readonly Talent: 'radar';
} = filterKeysSchema.enum;
export type FilterKeys = z.infer<typeof filterKeysSchema>;
export type FilterKeysRaw = boolean | readonly string[];
